/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Meta_TitleInputs */

const en_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book a Lesson | Mark Egly Golf`)
};

const es_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservar una lección | Mark Egly Golf`)
};

const de_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Golfstunde buchen | Mark Egly Golf`)
};

const zh_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`预约课程 | Mark Egly Golf`)
};

const ar_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`احجز درساً | Mark Egly Golf`)
};

const fr_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réservez une leçon | Mark Egly Golf`)
};

const vi_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đặt lịch học | Mark Egly Golf`)
};

const sw_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Weka Nafasi ya Somo | Mark Egly Golf`)
};

const th_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จองบทเรียน | Mark Egly Golf`)
};

const bs_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rezervišite lekciju | Mark Egly Golf`)
};

const ja_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レッスンのご予約 | Mark Egly Golf`)
};

const ko_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`레슨 예약 | Mark Egly Golf`)
};

const pt_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agende uma aula | Mark Egly Golf`)
};

const it_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prenota una lezione | Mark Egly Golf`)
};

const sv_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boka en lektion | Mark Egly Golf`)
};

const nl_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boek een les | Mark Egly Golf`)
};

const da_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book en lektion | Mark Egly Golf`)
};

const nb_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bestill en time | Mark Egly Golf`)
};

const fi_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Varaa oppitunti | Mark Egly Golf`)
};

const pl_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj lekcję | Mark Egly Golf`)
};

const ru_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запись на урок | Mark Egly Golf`)
};

const tr_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ders rezervasyonu | Mark Egly Golf`)
};

const hi_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पाठ बुक करें | Mark Egly Golf`)
};

const id_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesan Pelajaran | Mark Egly Golf`)
};

const ms_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempah pelajaran | Mark Egly Golf`)
};

const cs_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezervujte si lekci | Mark Egly Golf`)
};

const el_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κλείστε μάθημα | Mark Egly Golf`)
};

const he_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הזמנת שיעור | Mark Egly Golf`)
};

const af_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bespreek 'n les | Mark Egly Golf`)
};

const hu_booking_meta_title = /** @type {(inputs: Booking_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Foglalj órát | Mark Egly Golf`)
};

/**
* | output |
* | --- |
* | "Book a Lesson \| Mark Egly Golf" |
*
* @param {Booking_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const booking_meta_title = /** @type {((inputs?: Booking_Meta_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Meta_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_booking_meta_title(inputs)
	if (locale === "de") return de_booking_meta_title(inputs)
	if (locale === "zh") return zh_booking_meta_title(inputs)
	if (locale === "ar") return ar_booking_meta_title(inputs)
	if (locale === "fr") return fr_booking_meta_title(inputs)
	if (locale === "vi") return vi_booking_meta_title(inputs)
	if (locale === "sw") return sw_booking_meta_title(inputs)
	if (locale === "th") return th_booking_meta_title(inputs)
	if (locale === "bs") return bs_booking_meta_title(inputs)
	if (locale === "ja") return ja_booking_meta_title(inputs)
	if (locale === "ko") return ko_booking_meta_title(inputs)
	if (locale === "pt") return pt_booking_meta_title(inputs)
	if (locale === "it") return it_booking_meta_title(inputs)
	if (locale === "sv") return sv_booking_meta_title(inputs)
	if (locale === "nl") return nl_booking_meta_title(inputs)
	if (locale === "da") return da_booking_meta_title(inputs)
	if (locale === "nb") return nb_booking_meta_title(inputs)
	if (locale === "fi") return fi_booking_meta_title(inputs)
	if (locale === "pl") return pl_booking_meta_title(inputs)
	if (locale === "ru") return ru_booking_meta_title(inputs)
	if (locale === "tr") return tr_booking_meta_title(inputs)
	if (locale === "hi") return hi_booking_meta_title(inputs)
	if (locale === "id") return id_booking_meta_title(inputs)
	if (locale === "ms") return ms_booking_meta_title(inputs)
	if (locale === "cs") return cs_booking_meta_title(inputs)
	if (locale === "el") return el_booking_meta_title(inputs)
	if (locale === "he") return he_booking_meta_title(inputs)
	if (locale === "af") return af_booking_meta_title(inputs)
	if (locale === "hu") return hu_booking_meta_title(inputs)
	return en_booking_meta_title(inputs)
});